module.exports = __webpack_public_path__ + "img/card_赛事认证@2x.5ac4a143.png";